export const ROUTE_TAG_FEATURES = 'ROUTE_TAG_FEATURES';
export const ROUTE_TAG_APP_PAGES = 'ROUTE_TAG_APP_PAGES';
export const ROUTE_TAG_CURRENT_NETWORK = 'ROUTE_TAG_CURRENT_NETWORK';
export const ROUTE_TAG_PAGE_CUSTOMIZABLES = 'ROUTE_TAG_PAGE_CUSTOMIZABLES';
export const ROUTE_TAG_LOGIN_SETTINGS = 'ROUTE_TAG_LOGIN_SETTINGS';
